import { ListItem, ListItemText } from '@mui/material';
import ProductListRemoveIcon from '../products-list/product-list-remove-icon/product-list-item-remove.component';
import ProductListSingleItemListItem from './product-list-single-item-list-item/product-list-single-item-list-item.component';

const ProductListSingleItem = ({ item }) => {
  return (
    <ListItem
      secondaryAction={<ProductListRemoveIcon item={item} />}
      key={item.id}
      sx={theme => ({
        boxSizing: 'border-box',
        border: '1px solid',
        borderColor: theme.palette.text.secondary,
        borderRadius: 2,
        marginY: 1,
        paddingLeft: '5px',
        paddingRight: '40px',
        boxShadow: 1,
      })}
      data-testid="CardItem"
    >
      <ListItemText
        primary={<ProductListSingleItemListItem item={item} />}
        sx={{ marginLeft: 1 }}
      />
    </ListItem>
  );
};

export default ProductListSingleItem;
